module.exports = __webpack_public_path__ + "img/logo.247520d0.png";